import { useQuery } from '@tanstack/react-query';

import { QueryKeys, StorageKeys } from 'utils/constants';
import { LocationDetail } from './useGetLocations';

export const useGetLocationHistory = () => {
  const getLocationHistory = async (): Promise<LocationDetail[]> => {
    return new Promise((resolve, reject) => {
      try {
        const locations = JSON.parse(localStorage.getItem(StorageKeys.LocationHistory) || '[]');

        return resolve(locations);
      } catch (err) {
        return reject(err);
      }
    });
  };

  return useQuery({
    queryKey: [QueryKeys.LocationHistory],
    queryFn: getLocationHistory,
  });
};
